var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('div',{class:['displayer', 'displayer-'+_vm.type],style:({width:_vm.width}),attrs:{"role":"display"}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-316588f0","hasScoped":false,"buble":{"transforms":{}}}!./src/displayer/template.html
// module id = 164
// module chunks = 0